import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import predictionsReducer from "redux-toolkit/predictions/slice";
import predictorsReducer from "redux-toolkit/predictors/slice";

const combinedReducer = combineReducers({
  predictions: predictionsReducer,
  predictors: predictorsReducer,
});

export const store = configureStore({
  reducer: combinedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
});
